module.exports = __webpack_public_path__ + "static/media/icon-status-unset.5d39180e.svg";